export default __webpack_public_path__ + "static/media/WordmarkViolet.cb67847b.svg";